/* TODO: Удалить строки с игнорированием TS в задаче PUB-4328 (Оптимизация обработки кодов) */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { computed, type Ref } from 'vue'
import { cloneDeep } from 'lodash-es'
import { processCodes } from '@/lib/dataProcessor/dataHandlers'


function filterActualCodes(items: any, idField = 'id') {
  const filtered: Record<string, any> = {}
  Object.entries(items.value).forEach(([_, code]) => {
    if (!code || code.is_deprecated) {
      return
    }
    filtered[code[idField]] = code
  })
  return filtered
}

export function useProcessedCodes(codeTree: Ref<any>) {
  const allCodesById = computed(() => processCodes(cloneDeep(codeTree.value), 'id'))

  const allCodesByUid = computed(() => processCodes(cloneDeep(codeTree.value), 'uid'))

  const allActualCodesById = computed(() =>
    filterActualCodes(allActualCodesByUid, 'id'),
  )

  const allActualCodesByUid = computed(() =>
    filterActualCodes(allCodesByUid, 'uid'),
  )

  return {
    allCodesById,
    allActualCodesById,

    allCodesByUid,
    allActualCodesByUid,
  }
}
